const getFellowDriverFee = (client, params) => client.request({
  url: '/v1/application/contract/fellowDriverFee',
  method: 'get',
  params,
});

const getFellowDriverInfo = (client, params) => client.request({
  url: '/v1/application/contract/fellowDriverInfo',
  method: 'get',
  params,
});

const createApplicationAndContract = (client, data) => client.request({
  url: '/v1/application/contract',
  method: 'post',
  data,
});

const getContractAdditional = (client, params) => client.request({
  url: '/v1/application/contract/additional',
  method: 'get',
  params,
});

const getSocarPayFinUrl = (client, params) => client.request({
  url: '/v1/application/contract/socarPayFinUrl',
  method: 'get',
  params,
});

const createFellowDriver = (client, data) => client.request({
  url: '/v1/application/contract/fellowDrivers',
  method: 'post',
  data,
});

const getApplicationCustody = (client, params) => client.request({
  url: '/v1/application/contract/applicationCustody',
  method: 'get',
  params,
});
export default {
  getFellowDriverInfo,
  getFellowDriverFee,
  createApplicationAndContract,
  getContractAdditional,
  createFellowDriver,
  getApplicationCustody,
  getSocarPayFinUrl,
};
